import type { ReactNode } from 'react'

import { lighten } from 'polished'
import styled, { css } from 'styled-components'

import { Link as LinkBase } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	type?: 'default' | 'dark'
	size?: 'default' | 'small'
	label: ReactNode
}

export const solidStyling = css<Props>`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	color: ${({ theme, type }) => (type === 'dark' ? theme.color.textContrast : theme.color.text)};
	background-color: ${({ theme, type }) => (type === 'dark' ? theme.color.secondary : theme.color.primary)};
	-webkit-font-smoothing: antialiased;
	font-weight: 500;
	font-family: ${helpers.font.family.header};
	font-size: ${({ theme, size }) => (size === 'small' ? theme.font.size.base : theme.font.size.large)};
	width: ${({ fullWidth }) => fullWidth && '100%'};
	border-radius: 40px;
	min-width: 140px;
	padding-top: 6px;
	padding-bottom: 6px;
	min-height: ${({ size }) => (size === 'small' ? '36px' : '46px')};
	padding-left: ${({ size }) => (size === 'small' ? '16px' : '24px')};
	padding-right: ${({ size }) => (size === 'small' ? '16px' : '24px')};
	transition: color 0.2s, background-color 0.2s;
	white-space: nowrap;
	text-align: center;
	margin: 0;
	text-decoration: none;

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme, type }) => (type === 'dark' ? lighten(0.05, theme.color.secondary) : theme.color.primaryLight)};
		text-decoration: none;
		color: ${helpers.color.textContrast};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		color: ${helpers.color.disabled};
	}

	> svg {
		flex-shrink: 0;
	}
`

export const LinkSolid = styled(LinkBase).attrs<Props>(({ label }) => ({
	children: label,
}))<Props>`
	${solidStyling};
`
